import React from 'react';

const categories = {
    news: { name: 'お知らせ', color: 'bg-gray-100 text-gray-800' },
    maintenance: { name: 'メンテナンス', color: 'bg-yellow-100 text-yellow-800' },
    incident: { name: '障害情報', color: 'bg-red-100 text-red-800' },
    release: { name: '機能追加', color: 'bg-blue-100 text-blue-800' },
    important: { name: '重要', color: 'bg-red-100 text-red-800' },
};

const CategoryBadge = ({ category }) => {
    const categoryInfo = categories[category] || categories['news'];
    return (
        <span className={`px-2 py-1 mr-3 inline-flex text-xs leading-5 font-semibold rounded-md ${categoryInfo.color}`}>
            {categoryInfo.name}
        </span>
    );
};

const Announcements = ({ items }) => {
  if (!items || items.length === 0) return null;

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString('ja-JP');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">
            お知らせ
          </h2>
        </div>
        <div className="space-y-2">
          {items.map((item) => (
            <details key={item.id} className="p-4 border-b border-gray-200 group">
              <summary className="flex items-center justify-between cursor-pointer list-none">
                <div className="flex items-center">
                    <p className="text-sm text-gray-500 mr-4 flex-shrink-0">
                        {formatDate(item.publishedAt)}
                    </p>
                    <div className="flex items-center">
                        <CategoryBadge category={item.category} />
                        <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-600">
                            {item.title}
                        </h3>
                    </div>
                </div>
                <div className="transition-transform duration-300 group-open:rotate-90">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-gray-500"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </summary>
              <div className="mt-4 pl-8 text-gray-700">
                <p style={{ whiteSpace: 'pre-wrap' }}>{item.content}</p>
              </div>
            </details>
          ))}
        </div>
        <div className="text-center mt-8">
            <a href="/announcements" className="text-blue-600 hover:text-blue-800 font-semibold">
                お知らせ一覧へ →
            </a>
        </div>
      </div>
    </section>
  );
};

export default Announcements;
